import getApiClient from '@/plugins/api-client'

export default {
    loadSymplaToken: function(id) {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`sympla_tokens/${id}`)
            .then(result => {
                self.symplaToken = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },
    saveSymplaToken: function() {
        const self = this,
            symplaTokenId = self.symplaToken.id

        if (symplaTokenId) {
            return self.updateSymplaToken()
        }

        return self.createSymplaToken()
    },
    createSymplaToken: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.post('sympla_tokens', self.symplaToken)
            .then(result => {
                self.symplaToken = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 424:
                        self.errors['token'] = error.response.data['hydra:description']
                        break;
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },
    updateSymplaToken: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.patch(`sympla_tokens/${self.symplaToken.id}`, self.symplaToken, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.symplaToken = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 424:
                        self.errors['symplaId'] = error.response.data['hydra:description']
                        break;
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },

    resetFormResult: function() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    }
}
